import React from 'react';
import { CONNECTION_TYPES } from '../config/connectionTypes';
import { X, Plus } from 'lucide-react';
import { ConnectionIcon } from '../utils/iconUtils';
import './DatabaseConnectionDialog.css';

/**
 * Add Connection Modal
 *
 * Shows a popup where users can select which type of connection to add
 */
const AddConnectionModal = ({ isOpen, onClose, onSelectType }) => {
  if (!isOpen) return null;

  const availableTypes = Object.values(CONNECTION_TYPES);

  const handleSelect = (typeId) => {
    onSelectType(typeId);
  };

  return (
    <div className="db-connection-overlay">
      <div className="db-connection-dialog add-connection-dialog">
        <div className="db-connection-header">
          <h2>
            <Plus size={20} />
            Add New Connection
          </h2>
          <button
            className="db-connection-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="db-connection-body add-connection-body">
          <div className="add-connection-subtitle">
            Select the type of connection you want to add:
          </div>

          <div className="add-connection-grid">
            {availableTypes.map(connType => (
              <button
                key={connType.id}
                className="add-connection-type-btn"
                onClick={() => handleSelect(connType.id)}
              >
                <span className="add-connection-type-icon"><ConnectionIcon iconName={connType.icon} size={20} /></span>
                <span className="add-connection-type-name">{connType.name}</span>
                {connType.description && (
                  <span className="add-connection-type-desc">
                    {connType.description.substring(0, 50)}{connType.description.length > 50 ? '...' : ''}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="db-connection-footer">
          <button
            className="db-btn db-btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddConnectionModal;
